import React from "react";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";

function Ui() {
  return (
    <div className="ui">
      <div className="container">
        <div className="row">
          <div className="col-md-12 otherProjects__title">
            <h3>Certifications</h3>
            <p>view the archieve</p>
          </div>
        </div>

        {/* {/* row 1 */}
        <div className="row ui-row">
          <div className="col-md-4">
            <a href="/img/projects/hazza.jpg" target="__blank">
              <img className="uiImg" src="/img/projects/hazza.jpg" alt="" />
            </a>
          </div>
          {/* <div className="col-md-4">
            <a
              target="_blank"
              href="https://www.behance.net/gallery/128976487/SEO-Website-Design"
            >
              <img className="uiImg" src="/img/projects/a2.png" alt="" />
            </a>
          </div>
          <div className="col-md-4">
            <a
              target="_blank"
              href="https://www.behance.net/gallery/128998641/Construction-Company-Website-Design"
            >
              <img className="uiImg" src="/img/projects/a3.png" alt="" />
            </a>
          </div> */}
        </div>
        <br />
        {/* ROW 2 */}
        {/* <div className="row ui-row">
          <div className="col-md-4">
            <a
              target="_blank"
              href="https://www.behance.net/gallery/128983579/City-Website-Design-Project"
            >
              <img className="uiImg" src="/img/projects/a4.png" alt="" />
            </a>
          </div>
          <div className="col-md-4">
            <a
              target="_blank"
              href="https://www.behance.net/gallery/129034953/SEO-Experts-Website"
            >
              <img className="uiImg" src="/img/projects/a5.png" alt="" />
            </a>
          </div>
          <div className="col-md-4">
            <a
              target="_blank"
              href="https://www.behance.net/gallery/129034287/Construction-Company-Website-Design"
            >
              <img className="uiImg" src="/img/projects/a6.png" alt="" />
            </a>
          </div>
        </div>
        <br /> */}
        {/* ROW 3 */}
        {/* <div className="row ui-row">
          <div className="col-md-4">
            <a
              target="_blank"
              href="https://www.behance.net/gallery/129035211/Muslim-Marriage-Website-Design"
            >
              <img className="uiImg" src="/img/projects/a7.png" alt="" />
            </a>
          </div>
          <div className="col-md-4">
            <a
              target="_blank"
              href="https://www.behance.net/gallery/127562471/Muslim-Marriage-Website-Design"
            >
              <img className="uiImg" src="/img/projects/a8.png" alt="" />
            </a>
          </div>
          <div className="col-md-4">
            <a
              target="_blank"
              href="https://www.instagram.com/p/CQolCCkDM-i/?utm_source=ig_web_copy_link"
            >
              <img className="uiImg" src="/img/projects/a9.png" alt="" />
            </a>
          </div>
        </div>
      <br /><br /> */}
        <div className="row justify-content-center">
          <a
            target="_blank"
            href="https://www.behance.net/muhammamustafa2"
            className="btn btn-work"
          >
            See More
          </a>
        </div>
      </div>
    </div>
  );
}

export default Ui;
